export default __webpack_public_path__ + "static/media/google_cloud2.b11179b8.svg";